import { IntegrationUpsert } from 'models/integrations'
import api from '../..'

export const testAuth = ({
    ...data
}: IntegrationUpsert) => {
  return api.post('integrations/zoom/test_zoom', data)
    .then((response) => response)
}

export default testAuth
